/**
 * Celestial Background - ULTRA BRIGHT Starry Night Sky
 * Maximum stars, brightest glow, dramatic animations
 * Impossible to miss!
 */

(function() {
  'use strict';

  // Wait for DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    generateStars();
    generateFeatureStars();
    generateSuperFeatureStars();
    generateShimmerParticles();
  }

  /**
   * Generate twinkling stars - MAXIMUM count for dense, bright sky
   */
  function generateStars() {
    const container = document.getElementById('celestial-stars');
    if (!container) return;

    const starCount = 650; // Increased from 450 for much denser starfield
    const fragment = document.createDocumentFragment();

    for (let i = 0; i < starCount; i++) {
      const star = document.createElement('div');
      const sizeClass = getStarSize();
      const colorClass = getStarColor();
      const animClass = getAnimationClass(sizeClass);
      
      star.className = 'star ' + sizeClass + (colorClass ? ' ' + colorClass : '') + (animClass ? ' ' + animClass : '');
      
      // Random position across entire viewport
      star.style.left = Math.random() * 100 + '%';
      star.style.top = Math.random() * 100 + '%';
      
      // FASTER twinkle timing - more dynamic
      const duration = 1 + Math.random() * 2.5; // 1-3.5s instead of 1.5-5.5s
      const delay = Math.random() * 5;
      
      star.style.setProperty('--twinkle-duration', duration + 's');
      star.style.setProperty('--twinkle-delay', delay + 's');
      
      // MUCH HIGHER opacity ranges for brighter stars
      const minOpacity = 0.6 + Math.random() * 0.2; // 0.6-0.8 min
      const maxOpacity = 0.95 + Math.random() * 0.05; // 0.95-1.0 max
      star.style.setProperty('--star-min-opacity', minOpacity);
      star.style.setProperty('--star-max-opacity', maxOpacity);
      
      // More dramatic scale variation
      star.style.setProperty('--star-scale', 1.3 + Math.random() * 0.5);
      
      fragment.appendChild(star);
    }

    container.appendChild(fragment);
  }

  /**
   * Generate special feature stars - large, VERY bright focal points
   */
  function generateFeatureStars() {
    const container = document.getElementById('celestial-stars');
    if (!container) return;

    const featureCount = 15; // Increased from 8 for more prominent stars
    const fragment = document.createDocumentFragment();

    for (let i = 0; i < featureCount; i++) {
      const star = document.createElement('div');
      
      // Feature stars get special class - more golden ones
      const isGolden = Math.random() < 0.35;
      star.className = 'star star-feature' + (isGolden ? ' star-feature-golden' : '');
      
      // Position across viewport for good coverage
      star.style.left = (8 + Math.random() * 84) + '%';
      star.style.top = (5 + Math.random() * 75) + '%';
      
      // Varied but dramatic animation
      const duration = 2.5 + Math.random() * 2;
      const delay = Math.random() * 4;
      
      star.style.setProperty('--twinkle-duration', duration + 's');
      star.style.setProperty('--twinkle-delay', delay + 's');
      
      fragment.appendChild(star);
    }

    container.appendChild(fragment);
  }

  /**
   * Generate SUPER feature stars - the absolute brightest beacons
   */
  function generateSuperFeatureStars() {
    const container = document.getElementById('celestial-stars');
    if (!container) return;

    const superCount = 5; // A few ultra-bright stars
    const fragment = document.createDocumentFragment();

    for (let i = 0; i < superCount; i++) {
      const star = document.createElement('div');
      star.className = 'star star-super-feature';
      
      // Spread across the sky
      star.style.left = (15 + (i * 18) + Math.random() * 10) + '%';
      star.style.top = (10 + Math.random() * 60) + '%';
      
      // Slow, dramatic animation
      const duration = 3 + Math.random() * 2;
      const delay = Math.random() * 3;
      
      star.style.setProperty('--twinkle-duration', duration + 's');
      star.style.setProperty('--twinkle-delay', delay + 's');
      
      fragment.appendChild(star);
    }

    container.appendChild(fragment);
  }

  /**
   * Generate shimmer particles - MORE for extra magic
   */
  function generateShimmerParticles() {
    const container = document.getElementById('celestial-stars');
    if (!container) return;

    const shimmerCount = 50; // Doubled from 25 for more sparkle
    const fragment = document.createDocumentFragment();

    for (let i = 0; i < shimmerCount; i++) {
      const shimmer = document.createElement('div');
      shimmer.className = 'star-shimmer';
      
      shimmer.style.left = Math.random() * 100 + '%';
      shimmer.style.top = Math.random() * 100 + '%';
      
      // Faster shimmer timing
      const duration = 1.5 + Math.random() * 2;
      const delay = Math.random() * 4;
      
      shimmer.style.setProperty('--shimmer-duration', duration + 's');
      shimmer.style.setProperty('--shimmer-delay', delay + 's');
      
      fragment.appendChild(shimmer);
    }

    container.appendChild(fragment);
  }

  /**
   * Get star size class based on distribution
   * MORE medium/large/bright stars for visibility
   */
  function getStarSize() {
    const rand = Math.random();
    if (rand < 0.25) return 'star-tiny';    // 25% tiny (reduced from 35%)
    if (rand < 0.48) return 'star-small';   // 23% small
    if (rand < 0.72) return 'star-medium';  // 24% medium (increased from 20%)
    if (rand < 0.90) return 'star-large';   // 18% large (increased from 14%)
    return 'star-bright';                    // 10% bright (increased from 6%)
  }

  /**
   * Get optional star color class
   * More colored stars for variety
   */
  function getStarColor() {
    const rand = Math.random();
    if (rand < 0.80) return null;           // 80% white
    if (rand < 0.90) return 'star-blue';    // 10% blue tint
    if (rand < 0.97) return 'star-gold';    // 7% gold tint
    return 'star-red';                       // 3% red tint
  }

  /**
   * Get animation variation class for more dynamic movement
   * MORE stars get animation classes
   */
  function getAnimationClass(sizeClass) {
    // 50% of stars get special animations (up from 30%)
    if (Math.random() > 0.5) return null;
    
    const rand = Math.random();
    if (rand < 0.30) return 'anim-flicker';
    if (rand < 0.55) return 'anim-pulse';
    if (rand < 0.80) return 'anim-sparkle';
    return 'anim-strobe';
  }

})();
